<template>
  <div>
    <table class="table table-bordered tableinfo">
      <tr>
        <td>
          <b>Nome Grupo:</b>
          {{dados.nomeGrupo}}
        </td>
        <td>
          <b>Descricao:</b>
          {{dados.descricao}}
        </td>
        <td class>
          <b>Tipo:</b>
          {{dados.Grupo_Fipe.nomeTipo}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ["dados"],
  data() {
    return {};
  },

  components: {}
};
</script>
<style lang="scss" scoped>
.tableinfo td {
  width: 1%;
}
</style>
